import axios from 'axios'
import fetch from 'auth/FetchInterceptor'

const S3Service = {}

const apiKeyHeaders = () => ({ 'X-API-KEY': process.env.REACT_APP_API_KEY })

S3Service.fetchFiles = function (params, recursive = false) {
	return fetch({
		url: '/media/s3/files-s3',
		method: 'get',
		params: { ...params, recursive },
	}).then((response) => response)
}

S3Service.deleteFiles = function (key) {
	return fetch({
		url: '/media/s3/files-s3',
		method: 'delete',
		data: { key },
	}).then((response) => response)
}

/**
 * Uploads files and returns `{ status: 'accepted', jobs: [{ jobId, originalName, kind, stage }] }`.
 * The server answers as soon as it has the bytes; processing progress is read via getUploadJobs().
 *
 * onUploadProgress(loaded, total) reports the real browser → API transfer.
 * signal (AbortSignal) cancels the transfer; axios 0.x only knows CancelToken, hence the bridge.
 */
S3Service.upload = function ({ path, files, usePrefix = false, onUploadProgress, signal }) {
	let formData = new FormData()
	for (const file of files) {
		formData.append('files', file)
	}
	const query = usePrefix && path ? `?prefix=${encodeURIComponent(path.replace(/\/+/g, '/'))}` : ''

	const cancelSource = axios.CancelToken.source()
	if (signal) {
		if (signal.aborted) cancelSource.cancel('Upload cancelled')
		else signal.addEventListener('abort', () => cancelSource.cancel('Upload cancelled'), { once: true })
	}

	return fetch({
		url: `/media/s3/upload-aws${query}`,
		method: 'post',
		data: formData,
		headers: apiKeyHeaders(),
		// Large videos take far longer than the global 60 s timeout.
		timeout: 0,
		cancelToken: cancelSource.token,
		onUploadProgress: (event) => {
			if (onUploadProgress && event.total) onUploadProgress(event.loaded, event.total)
		},
	}).then((response) => response)
}

S3Service.getUploadJobs = function (ids) {
	return fetch({
		url: '/media/s3/upload-aws/jobs',
		method: 'get',
		params: { ids: ids.join(',') },
		headers: apiKeyHeaders(),
	}).then((response) => response)
}

S3Service.createDirectory = function ({ name, prefix }) {
	return fetch({
		url: '/media/s3/files-s3/directory',
		method: 'post',
		data: { name, prefix: prefix || '' },
	}).then((response) => response)
}

S3Service.getFileUrl = function (key) {
	return fetch({
		url: '/media/s3/files-s3/url',
		method: 'get',
		params: { key },
	}).then((response) => response)
}

export default S3Service
